import React, { useEffect, useState } from "react";
import "./ContactMap.css";
import Card from "react-bootstrap/Card";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useWebSocket } from "../../../uiUtils/useWebSocket";
import { fetchContactCardRequest } from "../../../../../store/features/actions/opportunities/contactMapCardActions";
import { getNameInitials } from "../../../../../services/commonService";
import { ContactMapPlaceholder } from "./ContactMapPlaceholder";
import NoDataComp from "../../../genericComponents/uiElements/NoDataComp";
import AccessField from "../accessEmailComp/AccessField";
import { useTaskStatus } from "../../../../../context/TaskStatusContext";
import GeneratingLoader from "../../../genericComponents/uiElements/GeneratingLoader";
import { enrichContact } from "../../../../../services/iqApiV2";
import { useUser } from "../../../../../context/UserContext";
import { useBanner } from "../../../../../context/BannerContext";
import { dynamicSmartSort } from "../../../../TableComponents/dynamicSortFunction";
import TagOverflowHandlerV2 from "../../../uiUtils/TagOverflowHandlerV2";
import GenericTagComp from "../../../genericComponents/tag/GenericTagComp";

export default function ContactMapCard({ opportunityId }) {
  const showBanner = useBanner();
  const dispatch = useDispatch();
  const [status, setStatus] = useState("Processing...");
  const [result, setResult] = useState(null);
  const { clientName, accountName } = useParams();
  const { contactCardData, contactCardLoading, error } = useSelector(
    (state) => state?.contactCardReducer
  );
  const { user } = useUser();

  const handleOnAccessEmailClick = async (e, userId, apolloId, linkedInUrl) => {
    e.preventDefault();
    e.stopPropagation();
    const onSuccess = () => {
      showBanner({
        message: "Email Found",
        title: "Alert",
        type: "success",
        duration: 2000,
      });
    };

    const onError = () => {
      showBanner({
        message: "Email Not Found",
        title: "Alert",
        type: "error",
        duration: 2000,
      });
    };
    const resp = await enrichContact(
      userId,
      apolloId,
      linkedInUrl,
      onSuccess,
      onError
    );

    const updatedResult = result.map((item) =>
      item.id === apolloId ? { ...item, email: resp.email } : item
    );
    // const NO_EMAIL = "email_not_unlocked@domain.com"

    // setResult( dynamicSmartSort(updatedResult, "email", {
    //        isValidFn: (val) => val && val !== NO_EMAIL,
    //        validOnTop: true,
    //      })); // assuming you're using useState for tabData
    // console.log("resp", resp, result);
    setResult(updatedResult);
  };
  const { getTaskStatus } = useTaskStatus();
  const taskStatus = getTaskStatus(`opp_sidecard_contact_map_${opportunityId}`);

  useEffect(() => {
    if (taskStatus == "completed" || opportunityId) {
       dispatch(fetchContactCardRequest({ opportunityId,userId:user?.id }))
    }
  }, [taskStatus]);

  // useEffect(() => {
  //   if (opportunityId) {
  //     dispatch(
  //       fetchContactCardRequest({
  //         opportunityId,
  //       })
  //     );
  //   }
  // }, [opportunityId]);

  useEffect(() => {
    if (contactCardData) {
      setResult(contactCardData);
      setStatus("Completed!");
    } else if (error) {
      setStatus("Error loading data");
    }
  }, [contactCardData, error]);

  if (taskStatus == "pending" && taskStatus != "failed") {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <GeneratingLoader />
      </div>
    );
  }

  const normalizeText = (text) => {
  return text
    ?.replace(/_/g, ' ')                 // Replace underscores with spaces
    .replace(/\s+/g, ' ')                // Normalize multiple spaces
    .trim()                              // Trim leading/trailing spaces
    .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
};




  return (
    <div className="contact_map_wrapper">
      <div className="container">
        <div className="row">
          {contactCardLoading == true || result === null ? (
            <>
              <ContactMapPlaceholder numberOfCards={10} />
            </>
          ) : Object.keys(result).length === 0 ? (
            <div className="no-data-message">
              <NoDataComp
                message="Content is being generated"
                buttonText="Refresh"
                onButtonClick={() =>
                  dispatch(fetchContactCardRequest({ opportunityId,userId:user?.id }))
                }
              />
            </div>
          ) : (
            Object.entries(result || {}).map(([key, data]) => (
              <div className="col-md-6">
                <div className="contact_map_block">
                  <Card className="contact_map_card">
                    <Card.Body>
                      <div className="contact_head_block">
                        <div className="contact_initial_block">
                          {getNameInitials(data?.name)}{" "}
                        </div>

                        {data?.contact_type && (
                          <div className="influencer_block">
                            <img
                              src="/img/contact_ai.png"
                              className="ai_icon"
                              alt="icon"
                            />
                            <p className="influencer_text">
                              {data?.contact_type}
                            </p>
                          </div>
                        )}
                        <div>
                        <TagOverflowHandlerV2
                          data={data?.functions?.map((item) => normalizeText(item))}
                        />

                        </div>
                      </div>
                      <div className="contact_map_info_block">
                        <div className="contact_map_name_block">
                          <p className="contact_map_name"> {data?.name} </p>
                        </div>
                        <p className="contact_map_designation">{data?.title}</p>
                        <p className="contact_map_details">
                          {data?.city && `  ${data.city}`}
                          {data?.country && `, ${data.country}`}
                        </p>
                      </div>
                      <div className="access_mob_block">
                        <AccessField
                          field_name="email"
                          field_value={data?.email}
                          onAccessClick={(e) =>
                            handleOnAccessEmailClick(
                              e,
                              user?.id,
                              data.id,
                              data.linkedin_url
                            )
                          }
                        />
                        {data.linkedin_url && (
                          <a
                            href={data.linkedin_url}
                            className="access_mob_subbock"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="/img/linkedin-logo.png?v=4"
                              alt="LinkedIn"
                              width="15"
                               style={{maxHeight:"2.2rem"}}
                            />
                          </a>
                        )}
                      </div>

                      <GenericTagComp color={"blue"} text={data?.icp_keyword} />
                    </Card.Body>
                  </Card>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
